import React, { HTMLAttributes } from 'react';
import { styled } from '../../theme';
import {
  polymorphicForwardRef,
  type GDSCustomizableComponent,
  type PolymorphicComponentPropWithRef,
  type PolymorphicRef,
} from '../../types';
import { GenesisCoreInspector } from '../../test-utils/genesis-core-inspector';

export type GDSBoxProps<C extends React.ElementType> =
  PolymorphicComponentPropWithRef<
    C,
    {
      as?: React.ElementType;
      children?: React.ReactNode;
    }
  > &
    GDSCustomizableComponent &
    HTMLAttributes<HTMLElement>;

export type GDSBoxComponent = <C extends React.ElementType = 'div'>(
  props: GDSBoxProps<C>,
) => React.ReactElement | null;

const BaseBox = styled('div');
const DISPLAY_NAME = 'Box';

export const Box: GDSBoxComponent = polymorphicForwardRef(
  <C extends React.ElementType = 'div'>(
    {
      as: asElement,
      className,
      css,
      children,
      'data-testid': testId = `GDS-${DISPLAY_NAME}`,
      ...props
    }: GDSBoxProps<C>,
    ref?: PolymorphicRef<C>,
  ) => (
    <GenesisCoreInspector displayName={DISPLAY_NAME}>
      <BaseBox
        data-testid={testId}
        as={asElement}
        className={['GDS-box', className].join(' ')}
        css={{ ...css }}
        ref={ref}
        {...props}
      >
        {children}
      </BaseBox>
    </GenesisCoreInspector>
  ),
);

// @ts-ignore
Box.displayName = DISPLAY_NAME;
